module.exports = __webpack_public_path__ + "static/easyeducation-footerBanner-min-49d777f04e2e78779e4efe3aa40ba08d.jpg";